module.exports = __webpack_public_path__ + "img/title.dd15f3dc.png";